import React from 'react';
import Page from './page';

function TreploStudioPolicy() {
    return (
        <Page label="Treplo Studio — Legal" title="Privacy Policy">
            <div className="doc">
                <p>Privacy policy coming soon.</p>
            </div>
        </Page>
    );
}

export default TreploStudioPolicy;
